import { IconButton } from './IconButton'
import { Share as BaseShare } from './Share'

export const Share = Object.assign(BaseShare, { IconButton })
